<template lang="pug">
.international-privacy
  .header(v-if="isZeta")
    safe-area-top
    .content
      .btn-back(@click="onClickBack")

  .privacy
    .title {{ title }}

    .introduction {{ introduction }}

    .content(v-for="(item, i) of content", :key="i")
      .sub-title {{ item.subtitle }}
      .paragraph {{ item.paragraph }}

  safe-area-bottom
</template>

<script>
import QueryString from "query-string"
import { closeWebView } from "@aries/webview"

import SafeAreaBottom from "@/components/safe-area/safe-area-bottom.vue"
import SafeAreaTop from "@/components/safe-area/safe-area-top.vue"
import ConfigSpaceService from "@/services/config-space"
import { isZeta } from "@/utils/shared"

export default {
  components: {
    SafeAreaTop,
    SafeAreaBottom
  },

  data() {
    return {
      isZeta,
      content: [],
      title: "",
      introduction: "",
      qs: {}
    }
  },

  async mounted() {
    this.qs = QueryString.parse(window.location.search)
    this.getPrivacyData()
  },

  methods: {
    async getPrivacyData() {
      const { key = "", namespace = "", from = "" } = this.qs

      // 如果由重定向而来(privacy.html)则说明走的国内域名，则调用国内域名接口
      const { privacy = {} } =
        from === "redirect"
          ? await ConfigSpaceService.getConfig(namespace, key)
          : await ConfigSpaceService.getZetaConfig(namespace, key)

      this.title = privacy.title ?? ""
      this.content = privacy.content ?? []
      this.introduction = privacy.introduction ?? ""
    },

    onClickBack() {
      closeWebView()
    }
  }
}
</script>

<style lang="stylus">
img,
a
  -webkit-touch-callout none
</style>

<style lang="stylus">
@import '~@/assets/common/font/font.gothic.styl'

html,
body
  overflow hidden

.international-privacy
  display flex
  flex-flow column nowrap
  height 100vh
  background linear-gradient(168.13deg, #561C69 0%, #0B1562 49.47%, #0A276C 98.94%)

  .header
    flex 0
    position relative
    box-sizing border-box
    width 100%
    height auto
    padding 0 18px

    .content
      position relative
      display flex
      align-items center
      height 56px

      .btn-back
        position relative
        width 32px
        height 32px
        background url('~@/assets/common/back.png') no-repeat
        background-size contain

  .privacy
    flex 1
    padding 0 24px 16px 24px
    overflow auto

    .title
      margin-top 16px
      color #FFFFFF
      font-size 28px
      setGothicFontByFontWeight(700)

    .introduction
      margin-top 16px
      color #FFFFFF
      letter-spacing 0
      opacity 0.7
      font-size 16px
      line-height 24px
      setGothicFontByFontWeight(400)

    .sub-title
      margin 24px 0 10px 0
      color #FFFFFF
      letter-spacing 0
      font-size 18px
      line-height 27px
      setGothicFontByFontWeight(500)

    .paragraph
      font-size 14px
      color #FFFFFF
      opacity 0.7
      letter-spacing 0
      line-height 16px
      line-height 24px
      white-space break-spaces
      setGothicFontByFontWeight(400)
</style>
